// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedPackage: null
}

const packages = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_PACKAGES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_PACKAGES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_PACKAGE':
      return { ...state, selectedPackage: action.selectedPackage }
    case 'ADD_PACKAGE':
      return { ...state }
    case 'DELETE_PACKAGE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default packages
